// // import React from "react"
// // import { useState, useEffect } from "react"
// // import { Card, Container, Row, Col, Button, Badge, Form, Modal, Alert, Spinner } from "react-bootstrap"
// // import {
// //   FaCalendarAlt,
// //   FaClock,
// //   FaMapMarkerAlt,
// //   FaSearch,
// //   FaFilter,
// //   FaPlus,
// //   FaCheckCircle,
// //   FaTimesCircle,
// //   FaExclamationTriangle,
// //   FaStethoscope,
// //   FaEdit,
// //   FaEye,
// //   FaShieldAlt,
// //   FaCalendarPlus,
// // } from "react-icons/fa"
// // import { useAuth } from "../../context/AuthContext"
// // import apiService from "../../services/api"

// // export default function AdminAppointments() {
// //   const { user } = useAuth()
// //   const [searchTerm, setSearchTerm] = useState("")
// //   const [statusFilter, setStatusFilter] = useState("all")
// //   const [dateFilter, setDateFilter] = useState("all")
// //   const [selectedAppointment, setSelectedAppointment] = useState(null)
// //   const [showModal, setShowModal] = useState(false)
  
// //   // Appointment scheduling modal state
// //   const [showAppointmentModal, setShowAppointmentModal] = useState(false)
// //   const [appointmentForm, setAppointmentForm] = useState({
// //     patientId: '',
// //     doctorName: '',
// //     appointmentDate: '',
// //     appointmentTime: '',
// //     notes: '',
// //     price: ''
// //   })
// //   const [patients, setPatients] = useState([])
// //   const [submitting, setSubmitting] = useState(false)
// //   const [message, setMessage] = useState({ type: '', text: '' })
// //   const [appointments, setAppointments] = useState([])
// //   const [loading, setLoading] = useState(true)

// //   useEffect(() => {
// //     if (user) {
// //       fetchPatientsAndDoctors()
// //       fetchAppointments()
// //     }
// //   }, [user])

// //   const fetchPatientsAndDoctors = async () => {
// //     try {
// //       // Only fetch patients, not doctors
// //       const patientsResponse = await apiService.getPatients(1, 100);
      
// //       if (patientsResponse.success) {
// //         // Handle different response structures
// //         if (patientsResponse.data && patientsResponse.data.patients) {
// //           setPatients(patientsResponse.data.patients);
// //         } else if (patientsResponse.data && Array.isArray(patientsResponse.data)) {
// //           setPatients(patientsResponse.data);
// //         } else {
// //           console.log('Patients response structure:', patientsResponse);
// //           setPatients([]);
// //         }
// //       } else {
// //         console.error('Failed to fetch patients:', patientsResponse);
// //         setPatients([]);
// //       }
// //     } catch (error) {
// //       console.error('Error fetching patients:', error);
// //       setPatients([]);
// //     }
// //   }

// //   const fetchAppointments = async () => {
// //     try {
// //       setLoading(true)
// //       const response = await apiService.getAppointments(1, 100)
// //       if (response.success) {
// //         // Transform the API response to match the expected format
// //         const transformedAppointments = response.data.appointments || response.data || []
// //         setAppointments(transformedAppointments)
// //       } else {
// //         console.error('Failed to fetch appointments:', response)
// //         setAppointments([])
// //       }
// //     } catch (error) {
// //       console.error('Error fetching appointments:', error)
// //       setAppointments([])
// //     } finally {
// //       setLoading(false)
// //     }
// //   }


// //   const openAppointmentModal = () => {
// //     setShowAppointmentModal(true)
// //     // Set default date to today
// //     const today = new Date().toISOString().split('T')[0]
// //     setAppointmentForm(prev => ({ ...prev, appointmentDate: today }))
// //   }

// //   const handleAppointmentSubmit = async (e) => {
// //     e.preventDefault()
// //     setSubmitting(true)
    
// //     try {
// //       const appointmentData = {
// //         ...appointmentForm,
// //         adminId: user.id // Include admin ID for appointment ownership
// //       }
      
// //       const response = await apiService.createAppointment(appointmentData)
// //       if (response.success) {
// //         setMessage({ type: 'success', text: 'Appointment scheduled successfully!' })
// //         setShowAppointmentModal(false)
// //         setAppointmentForm({
// //           patientId: '',
// //           doctorName: '',
// //           appointmentDate: '',
// //           appointmentTime: '',
// //           notes: '',
// //           price: ''
// //         })
// //         // Refresh the page to show new appointment
// //         fetchAppointments()
// //       }
// //     } catch (error) {
// //       console.error('Error creating appointment:', error)
// //       setMessage({ type: 'danger', text: error.message || 'Failed to schedule appointment' })
// //     } finally {
// //       setSubmitting(false)
// //     }
// //   }

// //   const filteredAppointments = appointments.filter((appointment) => {
// //     const matchesSearch =
// //       (appointment.patient_name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
// //       (appointment.doctor_name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
// //       (appointment.notes || '').toLowerCase().includes(searchTerm.toLowerCase())

// //     const matchesStatus = statusFilter === "all" || (appointment.status || '').toLowerCase() === statusFilter.toLowerCase()

// //     const today = new Date().toISOString().split('T')[0]
// //     const tomorrow = new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString().split('T')[0]
    
// //     const matchesDate =
// //       dateFilter === "all" ||
// //       (dateFilter === "today" && appointment.appointment_date === today) ||
// //       (dateFilter === "tomorrow" && appointment.appointment_date === tomorrow)

// //     return matchesSearch && matchesStatus && matchesDate
// //   })

// //   const getStatusIcon = (status) => {
// //     switch (status) {
// //       case "Completed":
// //         return <FaCheckCircle />
// //       case "Scheduled":
// //         return <FaClock />
// //       case "In Progress":
// //         return <FaExclamationTriangle />
// //       case "Cancelled":
// //         return <FaTimesCircle />
// //       default:
// //         return <FaExclamationTriangle />
// //     }
// //   }

// //   const scheduledAppointments = appointments.filter((apt) => apt.status === "Scheduled").length
// //   const completedAppointments = appointments.filter((apt) => apt.status === "Completed").length
// //   const inProgressAppointments = appointments.filter((apt) => apt.status === "In Progress").length
// //   const cancelledAppointments = appointments.filter((apt) => apt.status === "Cancelled").length

// //   const handleViewDetails = (appointment) => {
// //     setSelectedAppointment(appointment)
// //     setShowModal(true)
// //   }

// //   return (
// //     <div className="min-vh-100" style={{ backgroundColor: "#f8fffe" }}>
// //       <Container className="py-5">
// //         {/* Header */}
// //         <div className="mb-5">
// //           <div
// //             className="p-5 rounded-4 text-white position-relative overflow-hidden"
// //             style={{
// //               background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
// //             }}
// //           >
// //             {/* Background Pattern */}
// //             <div className="position-absolute w-100 h-100 top-0 start-0">
// //               <div
// //                 className="position-absolute rounded-circle opacity-10"
// //                 style={{
// //                   width: "200px",
// //                   height: "200px",
// //                   background: "white",
// //                   top: "-50px",
// //                   right: "-50px",
// //                 }}
// //               ></div>
// //             </div>

// //             <Row className="align-items-center position-relative">
// //               <Col md={8}>
// //                 <div className="mb-3">
// //                   <Badge
// //                     className="px-3 py-2 rounded-pill fw-medium mb-3"
// //                     style={{
// //                       backgroundColor: "rgba(255, 255, 255, 0.2)",
// //                       backdropFilter: "blur(10px)",
// //                       border: "1px solid rgba(255, 255, 255, 0.3)",
// //                     }}
// //                   >
// //                     <FaShieldAlt className="me-2" />
// //                     Appointment Management
// //                   </Badge>
// //                 </div>
// //                 <h1 className="display-5 fw-bold mb-3">Appointment Schedule</h1>
// //                 <p className="fs-5 opacity-90 mb-4">Manage and monitor all Aidify appointments</p>
// //                 <Button
// //                   variant="light"
// //                   className="px-4 py-2 rounded-pill fw-medium"
// //                   style={{
// //                     boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
// //                   }}
// //                   onClick={openAppointmentModal}
// //                 >
// //                   <FaPlus className="me-2" style={{ color: "#0891b2" }} />
// //                   <span style={{ color: "#0891b2" }}>Schedule Appointment</span>
// //                 </Button>
// //               </Col>
// //               <Col md={4} className="text-end">
// //                 <div
// //                   className="d-inline-flex align-items-center justify-content-center rounded-circle"
// //                   style={{
// //                     width: "120px",
// //                     height: "120px",
// //                     backgroundColor: "rgba(255, 255, 255, 0.2)",
// //                     backdropFilter: "blur(20px)",
// //                     border: "1px solid rgba(255, 255, 255, 0.3)",
// //                   }}
// //                 >
// //                   <FaCalendarAlt size={48} />
// //                 </div>
// //               </Col>
// //             </Row>
// //           </div>
// //         </div>

// //         {/* Stats Cards */}
// //         <Row className="g-4 mb-5">
// //           <Col md={3}>
// //             <Card
// //               className="border-0 rounded-4 h-100"
// //               style={{
// //                 boxShadow: "0 10px 40px rgba(8, 145, 178, 0.15)",
// //                 background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
// //               }}
// //             >
// //               <Card.Body className="p-4 text-white text-center">
// //                 <FaClock size={32} className="mb-3" />
// //                 <div className="h3 fw-bold mb-1">{scheduledAppointments}</div>
// //                 <div className="opacity-90">Scheduled</div>
// //               </Card.Body>
// //             </Card>
// //           </Col>

// //           <Col md={3}>
// //             <Card
// //               className="border-0 rounded-4 h-100"
// //               style={{
// //                 boxShadow: "0 10px 40px rgba(5, 150, 105, 0.15)",
// //                 background: "linear-gradient(135deg, #059669 0%, #047857 100%)",
// //               }}
// //             >
// //               <Card.Body className="p-4 text-white text-center">
// //                 <FaCheckCircle size={32} className="mb-3" />
// //                 <div className="h3 fw-bold mb-1">{completedAppointments}</div>
// //                 <div className="opacity-90">Completed</div>
// //               </Card.Body>
// //             </Card>
// //           </Col>

// //           <Col md={3}>
// //             <Card
// //               className="border-0 rounded-4 h-100"
// //               style={{
// //                 boxShadow: "0 10px 40px rgba(245, 158, 11, 0.15)",
// //                 background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
// //               }}
// //             >
// //               <Card.Body className="p-4 text-white text-center">
// //                 <FaExclamationTriangle size={32} className="mb-3" />
// //                 <div className="h3 fw-bold mb-1">{inProgressAppointments}</div>
// //                 <div className="opacity-90">In Progress</div>
// //               </Card.Body>
// //             </Card>
// //           </Col>

// //           <Col md={3}>
// //             <Card
// //               className="border-0 rounded-4 h-100"
// //               style={{
// //                 boxShadow: "0 10px 40px rgba(220, 38, 38, 0.15)",
// //                 background: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
// //               }}
// //             >
// //               <Card.Body className="p-4 text-white text-center">
// //                 <FaTimesCircle size={32} className="mb-3" />
// //                 <div className="h3 fw-bold mb-1">{cancelledAppointments}</div>
// //                 <div className="opacity-90">Cancelled</div>
// //               </Card.Body>
// //             </Card>
// //           </Col>
// //         </Row>

// //         {/* Filters */}
// //         <Card className="border-0 rounded-4 mb-4" style={{ boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)" }}>
// //           <Card.Header className="bg-transparent border-0 p-4">
// //             <div className="d-flex align-items-center">
// //               <div
// //                 className="rounded-circle me-3 d-flex align-items-center justify-content-center"
// //                 style={{
// //                   width: "40px",
// //                   height: "40px",
// //                   background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
// //                   color: "white",
// //                 }}
// //               >
// //                 <FaFilter size={18} />
// //               </div>
// //               <div>
// //                 <h5 className="fw-bold mb-1" style={{ color: "#1f2937" }}>
// //                   Filter Appointments
// //                 </h5>
// //                 <p className="text-muted mb-0">Search and filter appointment records</p>
// //               </div>
// //             </div>
// //           </Card.Header>
// //           <Card.Body className="p-4">
// //             <Row className="g-3">
// //               <Col md={6}>
// //                 <div className="position-relative">
// //                   <FaSearch className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted" />
// //                   <Form.Control
// //                     type="text"
// //                     placeholder="Search by patient, doctor, or specialty..."
// //                     value={searchTerm}
// //                     onChange={(e) => setSearchTerm(e.target.value)}
// //                     className="ps-5 rounded-3 border-0"
// //                     style={{
// //                       backgroundColor: "#f0fdfa",
// //                       boxShadow: "0 0 0 1px #a7f3d0",
// //                     }}
// //                   />
// //                 </div>
// //               </Col>
// //               <Col md={3}>
// //                 <Form.Select
// //                   value={statusFilter}
// //                   onChange={(e) => setStatusFilter(e.target.value)}
// //                   className="rounded-3 border-0"
// //                   style={{
// //                     backgroundColor: "#f0fdfa",
// //                     boxShadow: "0 0 0 1px #a7f3d0",
// //                   }}
// //                 >
// //                   <option value="all">All Status</option>
// //                   <option value="scheduled">Scheduled</option>
// //                   <option value="in progress">In Progress</option>
// //                   <option value="completed">Completed</option>
// //                   <option value="cancelled">Cancelled</option>
// //                 </Form.Select>
// //               </Col>
// //               <Col md={3}>
// //                 <Form.Select
// //                   value={dateFilter}
// //                   onChange={(e) => setDateFilter(e.target.value)}
// //                   className="rounded-3 border-0"
// //                   style={{
// //                     backgroundColor: "#f0fdfa",
// //                     boxShadow: "0 0 0 1px #a7f3d0",
// //                   }}
// //                 >
// //                   <option value="all">All Dates</option>
// //                   <option value="today">Today</option>
// //                   <option value="tomorrow">Tomorrow</option>
// //                 </Form.Select>
// //               </Col>
// //             </Row>
// //           </Card.Body>
// //         </Card>

// //         {/* Appointments List */}
// //         <Card className="border-0 rounded-4" style={{ boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)" }}>
// //           <Card.Header className="bg-transparent border-0 p-4">
// //             <div className="d-flex justify-content-between align-items-center">
// //               <div>
// //                 <h5 className="fw-bold mb-1" style={{ color: "#1f2937" }}>
// //                   Appointment Records
// //                 </h5>
// //                 <p className="text-muted mb-0">{filteredAppointments.length} appointment(s) found</p>
// //               </div>
// //             </div>
// //           </Card.Header>
// //           <Card.Body className="p-0">
// //             {loading ? (
// //               <div className="text-center py-5">
// //                 <Spinner animation="border" variant="primary" className="me-3" />
// //                 <span>Loading appointments...</span>
// //               </div>
// //             ) : filteredAppointments.length > 0 ? (
// //               <div className="d-flex flex-column">
// //                 {filteredAppointments.map((appointment, index) => (
// //                   <div
// //                     key={appointment.id}
// //                     className={`p-4 d-flex justify-content-between align-items-center ${
// //                       index !== filteredAppointments.length - 1 ? "border-bottom" : ""
// //                     }`}
// //                     style={{
// //                       borderColor: "#a7f3d0",
// //                       transition: "all 0.3s ease",
// //                     }}
// //                     onMouseEnter={(e) => {
// //                       e.currentTarget.style.backgroundColor = "#f0fdfa"
// //                     }}
// //                     onMouseLeave={(e) => {
// //                       e.currentTarget.style.backgroundColor = "transparent"
// //                     }}
// //                   >
// //                     <div className="d-flex align-items-center">
// //                       <div
// //                         className="rounded-circle me-4 d-flex align-items-center justify-content-center"
// //                         style={{
// //                           width: "60px",
// //                           height: "60px",
// //                           background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
// //                           color: "white",
// //                         }}
// //                       >
// //                         <FaStethoscope size={24} />
// //                       </div>
// //                       <div>
// //                         <div className="fw-bold mb-1" style={{ color: "#1f2937" }}>
// //                           {appointment.patient_name}
// //                         </div>
// //                         <div className="text-muted mb-1">{appointment.doctor_name}</div>
// //                         <div className="text-muted small mb-1">{appointment.notes || 'No notes'}</div>
// //                         <div className="d-flex align-items-center text-muted small">
// //                           <FaCalendarAlt className="me-1" size={12} />
// //                           {appointment.appointment_date} at {appointment.appointment_time}
// //                         </div>
// //                       </div>
// //                     </div>
// //                     <div className="text-end">
// //                       <Badge
// //                         className="mb-2 d-flex align-items-center gap-1 w-fit ms-auto"
// //                         style={{
// //                           background:
// //                             appointment.status === "Completed"
// //                               ? "linear-gradient(135deg, #059669 0%, #047857 100%)"
// //                               : appointment.status === "Scheduled"
// //                                 ? "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)"
// //                                 : appointment.status === "In Progress"
// //                                   ? "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)"
// //                                   : "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
// //                           border: "none",
// //                         }}
// //                       >
// //                         {getStatusIcon(appointment.status)}
// //                         {appointment.status}
// //                       </Badge>
// //                       <div className="d-flex gap-2">
// //                         <Button
// //                           size="sm"
// //                           variant="outline-primary"
// //                           className="rounded-pill"
// //                           onClick={() => handleViewDetails(appointment)}
// //                           style={{ borderColor: "#0891b2", color: "#0891b2" }}
// //                         >
// //                           <FaEye className="me-1" size={12} />
// //                           View
// //                         </Button>
// //                         <Button size="sm" variant="outline-success" className="rounded-pill">
// //                           <FaEdit className="me-1" size={12} />
// //                           Edit
// //                         </Button>
// //                       </div>
// //                     </div>
// //                   </div>
// //                 ))}
// //               </div>
// //             ) : (
// //               <div className="text-center py-5">
// //                 <FaCalendarAlt size={64} className="text-muted mb-3" />
// //                 <h5 className="text-muted mb-2">No appointments found</h5>
// //                 <p className="text-muted mb-4">Try adjusting your search criteria or schedule a new appointment</p>
// //                 <Button
// //                   className="px-4 py-2 rounded-pill fw-medium border-0"
// //                   style={{
// //                     background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
// //                   }}
// //                   onClick={openAppointmentModal}
// //                 >
// //                   <FaPlus className="me-2" />
// //                   Schedule New Appointment
// //                 </Button>
// //               </div>
// //             )}
// //           </Card.Body>
// //         </Card>

// //         {/* Appointment Details Modal */}
// //         <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
// //           <Modal.Header closeButton className="border-0">
// //             <Modal.Title>Appointment Details</Modal.Title>
// //           </Modal.Header>
// //           <Modal.Body className="p-4">
// //             {selectedAppointment && (
// //               <Row className="g-4">
// //                 <Col md={6}>
// //                   <h6 className="fw-bold mb-3" style={{ color: "#0891b2" }}>
// //                     Appointment Information
// //                   </h6>
// //                   <div className="mb-3">
// //                     <strong>Date:</strong> {selectedAppointment.appointment_date}
// //                   </div>
// //                   <div className="mb-3">
// //                     <strong>Time:</strong> {selectedAppointment.appointment_time}
// //                   </div>
// //                   <div className="mb-3">
// //                     <strong>Status:</strong> 
// //                     <Badge
// //                       className="ms-2"
// //                       style={{
// //                         background:
// //                           selectedAppointment.status === "Completed"
// //                             ? "linear-gradient(135deg, #059669 0%, #047857 100%)"
// //                             : selectedAppointment.status === "Scheduled"
// //                               ? "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)"
// //                               : selectedAppointment.status === "In Progress"
// //                                 ? "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)"
// //                                 : "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
// //                         border: "none",
// //                       }}
// //                     >
// //                       {selectedAppointment.status}
// //                     </Badge>
// //                   </div>
// //                   <div className="mb-3">
// //                     <strong>Patient:</strong> {selectedAppointment.patient_name}
// //                   </div>
// //                   <div className="mb-3">
// //                     <strong>Doctor:</strong> {selectedAppointment.doctor_name}
// //                   </div>
// //                   {selectedAppointment.price && (
// //                     <div className="mb-3">
// //                       <strong>Price:</strong> ${selectedAppointment.price}
// //                     </div>
// //                   )}
// //                   {selectedAppointment.notes && (
// //                     <div className="mb-3">
// //                       <strong>Notes:</strong> {selectedAppointment.notes}
// //                     </div>
// //                   )}
// //                 </Col>
// //                 <Col md={6}>
// //                   <h6 className="fw-bold mb-3" style={{ color: "#0891b2" }}>
// //                     Additional Information
// //                   </h6>
// //                   <div className="mb-3">
// //                     <strong>Created:</strong> {new Date(selectedAppointment.created_at).toLocaleDateString()}
// //                   </div>
// //                   {selectedAppointment.notes && (
// //                     <div className="mb-3">
// //                       <strong>Notes:</strong> {selectedAppointment.notes}
// //                     </div>
// //                   )}
// //                 </Col>
// //               </Row>
// //             )}
// //           </Modal.Body>
// //           <Modal.Footer className="border-0">
// //             <Button variant="outline-secondary" onClick={() => setShowModal(false)}>
// //               Close
// //             </Button>
// //             <Button
// //               style={{
// //                 background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
// //                 border: "none",
// //               }}
// //             >
// //               <FaEdit className="me-2" />
// //               Edit Appointment
// //             </Button>
// //           </Modal.Footer>
// //         </Modal>

// //         {/* Appointment Scheduling Modal */}
// //         <Modal show={showAppointmentModal} onHide={() => setShowAppointmentModal(false)} size="lg" centered>
// //           <Modal.Header closeButton style={{ backgroundColor: "#f0fdfa" }}>
// //             <Modal.Title>
// //               <FaCalendarPlus className="me-2" />
// //               Schedule New Appointment
// //             </Modal.Title>
// //           </Modal.Header>
// //           <Modal.Body>
// //             {message.text && (
// //               <Alert variant={message.type} dismissible onClose={() => setMessage({ type: '', text: '' })}>
// //                 {message.text}
// //               </Alert>
// //             )}
            
// //             <Form onSubmit={handleAppointmentSubmit}>
// //               <Row>
// //                 <Col md={6}>
// //                   <Form.Group className="mb-3">
// //                     <Form.Label>Patient <span className="text-danger">*</span></Form.Label>
// //                     <Form.Select
// //                       required
// //                       value={appointmentForm.patientId}
// //                       onChange={(e) => setAppointmentForm(prev => ({ ...prev, patientId: e.target.value }))}
// //                     >
// //                       <option value="">Select Patient</option>
// //                       {patients.map(patient => (
// //                         <option key={patient.id} value={patient.id}>
// //                           {patient.name} ({patient.email})
// //                         </option>
// //                       ))}
// //                     </Form.Select>
// //                   </Form.Group>
// //                 </Col>
// //                 <Col md={6}>
// //                   <Form.Group className="mb-3">
// //                     <Form.Label>Doctor <span className="text-danger">*</span></Form.Label>
// //                     <Form.Control
// //                       type="text"
// //                       placeholder="Enter doctor name"
// //                       value={appointmentForm.doctorName}
// //                       onChange={(e) => setAppointmentForm(prev => ({ ...prev, doctorName: e.target.value }))}
// //                     />
// //                   </Form.Group>
// //                 </Col>
// //               </Row>
              
// //               <Row>
// //                 <Col md={6}>
// //                   <Form.Group className="mb-3">
// //                     <Form.Label>Appointment Date <span className="text-danger">*</span></Form.Label>
// //                     <Form.Control
// //                       type="date"
// //                       required
// //                       value={appointmentForm.appointmentDate}
// //                       onChange={(e) => setAppointmentForm(prev => ({ ...prev, appointmentDate: e.target.value }))}
// //                       min={new Date().toISOString().split('T')[0]}
// //                     />
// //                   </Form.Group>
// //                 </Col>
// //                 <Col md={6}>
// //                   <Form.Group className="mb-3">
// //                     <Form.Label>Appointment Time <span className="text-danger">*</span></Form.Label>
// //                     <Form.Control
// //                       type="time"
// //                       required
// //                       value={appointmentForm.appointmentTime}
// //                       onChange={(e) => setAppointmentForm(prev => ({ ...prev, appointmentTime: e.target.value }))}
// //                     />
// //                   </Form.Group>
// //                 </Col>
// //               </Row>
              
// //               <Row>
// //                 <Col md={6}>
// //                   <Form.Group className="mb-3">
// //                     <Form.Label>Price</Form.Label>
// //                     <Form.Control
// //                       type="number"
// //                       placeholder="Enter price"
// //                       value={appointmentForm.price}
// //                       onChange={(e) => setAppointmentForm(prev => ({ ...prev, price: e.target.value }))}
// //                     />
// //                   </Form.Group>
// //                 </Col>
// //               </Row>
              
// //               <Form.Group className="mb-3">
// //                 <Form.Label>Notes</Form.Label>
// //                 <Form.Control
// //                   as="textarea"
// //                   rows={3}
// //                   placeholder="Additional notes..."
// //                   value={appointmentForm.notes}
// //                   onChange={(e) => setAppointmentForm(prev => ({ ...prev, notes: e.target.value }))}
// //                 />
// //               </Form.Group>
// //             </Form>
// //           </Modal.Body>
// //           <Modal.Footer style={{ backgroundColor: "#f0fdfa" }}>
// //             <Button variant="secondary" onClick={() => setShowAppointmentModal(false)}>
// //               Cancel
// //             </Button>
// //             <Button 
// //               variant="primary" 
// //               onClick={handleAppointmentSubmit}
// //               disabled={submitting}
// //             >
// //               {submitting ? (
// //                 <>
// //                   <Spinner animation="border" size="sm" className="me-2" />
// //                   Scheduling...
// //                 </>
// //               ) : (
// //                 <>
// //                   <FaCalendarPlus className="me-2" />
// //                   Schedule Appointment
// //                 </>
// //               )}
// //             </Button>
// //           </Modal.Footer>
// //         </Modal>
// //       </Container>
// //     </div>
// //   )
// // }


// import React, { useEffect, useState } from "react"
// import { Container, Row, Col, Card, Button, Modal, Form, Alert, Spinner } from "react-bootstrap"
// import { FaEye, FaEdit } from "react-icons/fa"
// import { useAuth } from "../../context/AuthContext"
// import apiService from "../../services/api"

// export default function AdminAppointments() {
//   const { user } = useAuth()

//   const [appointments, setAppointments] = useState([])
//   const [loading, setLoading] = useState(false)
//   const [message, setMessage] = useState(null)

//   // View modal
//   const [showViewModal, setShowViewModal] = useState(false)
//   const [viewAppointment, setViewAppointment] = useState(null)

//   // Edit modal (status only)
//   const [showEditModal, setShowEditModal] = useState(false)
//   const [editForm, setEditForm] = useState(null)
//   const [submitting, setSubmitting] = useState(false)

//   // --- Helpers ---
//   const normalizeAppointments = (resp) => {
//     const payload = resp?.data ?? resp
//     if (Array.isArray(payload?.appointments)) return payload.appointments
//     if (Array.isArray(payload)) return payload
//     if (Array.isArray(payload?.data?.appointments)) return payload.data.appointments
//     return []
//   }

//   // --- Fetch ---
//   const fetchAppointments = async () => {
//     setLoading(true)
//     try {
//       const response = await apiService.getAppointments(1, 100)
//       if (response?.success) {
//         const list = normalizeAppointments(response)
//         setAppointments(Array.isArray(list) ? list : [])
//       } else {
//         setAppointments([])
//         setMessage({ type: "danger", text: "Failed to fetch appointments" })
//       }
//     } catch (err) {
//       console.error("Error loading appointments", err)
//       setAppointments([])
//       setMessage({ type: "danger", text: "Error loading appointments" })
//     } finally {
//       setLoading(false)
//     }
//   }

//   useEffect(() => {
//     fetchAppointments()
//   }, [])

//   // --- Dynamic counts ---
//   const safeList = Array.isArray(appointments) ? appointments : []
//   const statusCounts = safeList.reduce((acc, apt) => {
//     const s = (apt?.status ?? "").toLowerCase()
//     acc[s] = (acc[s] || 0) + 1
//     return acc
//   }, {})

//   const scheduledAppointments = statusCounts["scheduled"] || 0
//   const completedAppointments = statusCounts["completed"] || 0
//   const inProgressAppointments = statusCounts["in-progress"] || 0
//   const cancelledAppointments = statusCounts["cancelled"] || 0

//   // --- View ---
//   const handleView = (appointment) => {
//     setViewAppointment(appointment)
//     setShowViewModal(true)
//   }

//   // --- Edit (status only) ---
//   const handleEdit = (appointment) => {
//     setEditForm({ ...appointment })
//     setShowEditModal(true)
//   }

//   const handleEditSubmit = async (e) => {
//     e.preventDefault()
//     if (!editForm) return
//     setSubmitting(true)

//     try {
//       const updatedAppointment = {
//         id: editForm.id,
//         patientId: String(
//           editForm.patient_id ?? editForm.patientId ?? editForm.patient?.id ?? ""
//         ),
//         doctorName: editForm.doctor_name ?? editForm.doctorName ?? "",
//         appointmentDate: new Date(editForm.appointment_date ?? editForm.appointmentDate)
//           .toISOString()
//           .slice(0, 10), // YYYY-MM-DD
//         appointmentTime: (editForm.appointment_time ?? editForm.appointmentTime ?? "").slice(0, 5),
//         notes: editForm.notes ?? "",
//         price: editForm.price ?? "",
//         adminId: user?.id,
//         status: editForm.status, // only editable field
//       }

//       // Use PUT for update
//       const response = await apiService.updateAppointment(editForm.id, updatedAppointment)

//       if (response?.success) {
//         setMessage({ type: "success", text: "Appointment updated successfully!" })
//         setShowEditModal(false)
//         fetchAppointments()
//       } else {
//         setMessage({ type: "danger", text: "Failed to update appointment" })
//       }
//     } catch (err) {
//       console.error("Error updating appointment", err)
//       setMessage({ type: "danger", text: err?.message || "Error updating appointment" })
//     } finally {
//       setSubmitting(false)
//     }
//   }

//   return (
//     <Container fluid className="p-4">
//       <h2 className="mb-4">Appointments Dashboard</h2>

//       {message && (
//         <Alert variant={message.type} onClose={() => setMessage(null)} dismissible>
//           {message.text}
//         </Alert>
//       )}

//       {/* Stats */}
//       <Row className="mb-4 g-3">
//         <Col md={3}>
//           <Card className="shadow-sm h-100">
//             <Card.Body>
//               <Card.Title>Scheduled</Card.Title>
//               <h4 className="mb-0">{scheduledAppointments}</h4>
//             </Card.Body>
//           </Card>
//         </Col>
//         <Col md={3}>
//           <Card className="shadow-sm h-100">
//             <Card.Body>
//               <Card.Title>Completed</Card.Title>
//               <h4 className="mb-0">{completedAppointments}</h4>
//             </Card.Body>
//           </Card>
//         </Col>
//         <Col md={3}>
//           <Card className="shadow-sm h-100">
//             <Card.Body>
//               <Card.Title>In Progress</Card.Title>
//               <h4 className="mb-0">{inProgressAppointments}</h4>
//             </Card.Body>
//           </Card>
//         </Col>
//         <Col md={3}>
//           <Card className="shadow-sm h-100">
//             <Card.Body>
//               <Card.Title>Cancelled</Card.Title>
//               <h4 className="mb-0">{cancelledAppointments}</h4>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Appointments List */}
//       <Row>
//         <Col>
//           {loading ? (
//             <div className="text-center p-5">
//               <Spinner animation="border" />
//             </div>
//           ) : (
//             <Card className="shadow-sm">
//               <Card.Body>
//                 <h5>All Appointments</h5>
//                 <div className="table-responsive">
//                   <table className="table table-hover align-middle">
//                     <thead>
//                       <tr>
//                         <th>ID</th>
//                         <th>Patient</th>
//                         <th>Doctor</th>
//                         <th>Date</th>
//                         <th>Time</th>
//                         <th>Status</th>
//                         <th>Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {safeList.length > 0 ? (
//                         safeList.map((apt) => (
//                           <tr key={apt.id}>
//                             <td>{apt.id}</td>
//                             <td>{apt.patient_name}</td>
//                             <td>{apt.doctor_name}</td>
//                             <td>{apt.appointment_date}</td>
//                             <td>{apt.appointment_time}</td>
//                             <td>{apt.status}</td>
//                             <td>
//                               <Button
//                                 size="sm"
//                                 variant="outline-primary"
//                                 className="me-2 rounded-pill"
//                                 onClick={() => handleView(apt)}
//                               >
//                                 <FaEye className="me-1" size={12} /> View
//                               </Button>
//                               <Button
//                                 size="sm"
//                                 variant="outline-success"
//                                 className="rounded-pill"
//                                 onClick={() => handleEdit(apt)}
//                               >
//                                 <FaEdit className="me-1" size={12} /> Edit
//                               </Button>
//                             </td>
//                           </tr>
//                         ))
//                       ) : (
//                         <tr>
//                           <td colSpan="7" className="text-center py-3">
//                             No appointments found
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </Card.Body>
//             </Card>
//           )}
//         </Col>
//       </Row>

//       {/* View Modal */}
//       <Modal show={showViewModal} onHide={() => setShowViewModal(false)} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Appointment Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {viewAppointment && (
//             <>
//               <p><b>Patient:</b> {viewAppointment.patient_name}</p>
//               <p><b>Doctor:</b> {viewAppointment.doctor_name}</p>
//               <p><b>Date:</b> {viewAppointment.appointment_date}</p>
//               <p><b>Time:</b> {viewAppointment.appointment_time}</p>
//               <p><b>Status:</b> {viewAppointment.status}</p>
//               <p><b>Notes:</b> {viewAppointment.notes || "N/A"}</p>
//               {viewAppointment.price && <p><b>Price:</b> {viewAppointment.price}</p>}
//             </>
//           )}
//         </Modal.Body>
//       </Modal>

//       {/* Edit Modal (status only) */}
//       <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Appointment</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {editForm && (
//             <Form onSubmit={handleEditSubmit}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Patient</Form.Label>
//                 <Form.Control type="text" value={editForm.patient_name} disabled />
//               </Form.Group>
//               <Form.Group className="mb-3">
//                 <Form.Label>Doctor</Form.Label>
//                 <Form.Control type="text" value={editForm.doctor_name} disabled />
//               </Form.Group>
//               <Row>
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>Date</Form.Label>
//                     <Form.Control type="text" value={editForm.appointment_date} disabled />
//                   </Form.Group>
//                 </Col>
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>Time</Form.Label>
//                     <Form.Control type="text" value={editForm.appointment_time} disabled />
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <Form.Group className="mb-3">
//                 <Form.Label>Status</Form.Label>
//                 <Form.Select
//                   value={editForm.status}
//                   onChange={(e) => setEditForm({ ...editForm, status: e.target.value })}
//                 >
//                   <option value="scheduled">Scheduled</option>
//                   <option value="in-progress">In Progress</option>
//                   <option value="completed">Completed</option>
//                   <option value="cancelled">Cancelled</option>
//                 </Form.Select>
//               </Form.Group>
//               <div className="text-end">
//                 <Button variant="secondary" className="me-2" onClick={() => setShowEditModal(false)}>
//                   Cancel
//                 </Button>
//                 <Button type="submit" variant="primary" disabled={submitting}>
//                   {submitting ? "Saving..." : "Save Changes"}
//                 </Button>
//               </div>
//             </Form>
//           )}
//         </Modal.Body>
//       </Modal>
//     </Container>
//   )
// }



import React from "react"
import { useState, useEffect } from "react"
import {
  Card,
  Container,
  Row,
  Col,
  Button,
  Badge,
  Form,
  Modal,
  Alert,
  Spinner,
} from "react-bootstrap"
import {
  FaCalendarAlt,
  FaClock,
  FaMapMarkerAlt,
  FaSearch,
  FaFilter,
  FaPlus,
  FaCheckCircle,
  FaTimesCircle,
  FaExclamationTriangle,
  FaStethoscope,
  FaEdit,
  FaEye,
  FaShieldAlt,
  FaCalendarPlus,
} from "react-icons/fa"
import { useAuth } from "../../context/AuthContext"
import apiService from "../../services/api"

export default function AdminAppointments() {
  const { user } = useAuth()

  // Filters & UI state
  const [searchTerm, setSearchTerm] = useState("")
  const [statusFilter, setStatusFilter] = useState("all")
  const [dateFilter, setDateFilter] = useState("all")

  // Modals & forms
  const [selectedAppointment, setSelectedAppointment] = useState(null)
  const [showViewModal, setShowViewModal] = useState(false)

  const [showEditModal, setShowEditModal] = useState(false)
  const [editForm, setEditForm] = useState(null)
  const [submittingEdit, setSubmittingEdit] = useState(false)

  const [showAppointmentModal, setShowAppointmentModal] = useState(false)
  const [appointmentForm, setAppointmentForm] = useState({
    patientId: "",
    doctorName: "",
    appointmentDate: "",
    appointmentTime: "",
    notes: "",
    price: "",
  })
  const [submittingCreate, setSubmittingCreate] = useState(false)

  // Data
  const [patients, setPatients] = useState([])
  const [appointments, setAppointments] = useState([])
  const [loading, setLoading] = useState(true)
  const [message, setMessage] = useState({ type: "", text: "" })

  // ----------------------
  // Fetch helpers
  // ----------------------
  const normalizeAppointmentsResponse = (resp) => {
    // support various shapes from API
    if (!resp) return []
    if (Array.isArray(resp)) return resp
    if (Array.isArray(resp.data)) return resp.data
    if (Array.isArray(resp.data?.appointments)) return resp.data.appointments
    if (Array.isArray(resp.appointments)) return resp.appointments
    // fallback - if success wrapper with data object containing array
    if (Array.isArray(resp?.data?.data)) return resp.data.data
    return []
  }

  const fetchPatientsAndDoctors = async () => {
    try {
      const patientsResponse = await apiService.getPatients?.(1, 100)
      if (patientsResponse?.success) {
        // try to extract array from different shapes
        const list =
          patientsResponse.data?.patients ??
          patientsResponse.data ??
          patientsResponse.patients ??
          patientsResponse
        if (Array.isArray(list)) {
          setPatients(list)
        } else {
          setPatients([])
          console.warn("Unexpected patients response structure", patientsResponse)
        }
      } else {
        console.error("Failed to fetch patients", patientsResponse)
        setPatients([])
      }
    } catch (err) {
      console.error("Error fetching patients", err)
      setPatients([])
    }
  }

  const fetchAppointments = async () => {
    try {
      setLoading(true)
      const response = await apiService.getAppointments?.(1, 100)
      if (response?.success) {
        const list = normalizeAppointmentsResponse(response)
        setAppointments(Array.isArray(list) ? list : [])
      } else {
        console.error("Failed to fetch appointments", response)
        setAppointments([])
        setMessage({ type: "danger", text: "Failed to fetch appointments" })
      }
    } catch (error) {
      console.error("Error fetching appointments", error)
      setAppointments([])
      setMessage({ type: "danger", text: "Error fetching appointments" })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (user) {
      fetchPatientsAndDoctors()
      fetchAppointments()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  // ----------------------
  // Derived counts (dynamic)
  // ----------------------
  const safeAppointments = Array.isArray(appointments) ? appointments : []
  // Normalize status keys to predictable lower-case versions:
  const normalizeStatusKey = (s) => {
    if (!s && s !== "") return ""
    const t = (s || "").toString().trim().toLowerCase()
    // map common variations
    if (t === "in progress" || t === "in-progress" || t === "inprogress")
      return "in progress"
    if (t === "scheduled") return "scheduled"
    if (t === "completed") return "completed"
    if (t === "cancelled" || t === "canceled") return "cancelled"
    return t // fallback
  }

  const statusCounts = safeAppointments.reduce((acc, apt) => {
    const key = normalizeStatusKey(apt.status)
    acc[key] = (acc[key] || 0) + 1
    return acc
  }, {})

  const scheduledAppointments = statusCounts["scheduled"] || 0
  const completedAppointments = statusCounts["completed"] || 0
  const inProgressAppointments = statusCounts["in progress"] || 0
  const cancelledAppointments = statusCounts["cancelled"] || 0

  // ----------------------
  // Filters
  // ----------------------
  const filteredAppointments = safeAppointments.filter((appointment) => {
    const term = searchTerm.trim().toLowerCase()
    const matchesSearch =
      !term ||
      (String(appointment.patient_name || appointment.patient?.name || "")
        .toLowerCase()
        .includes(term) ||
        String(appointment.doctor_name || appointment.doctorName || "")
          .toLowerCase()
          .includes(term) ||
        String(appointment.notes || "").toLowerCase().includes(term))

    const matchesStatus =
      statusFilter === "all" ||
      normalizeStatusKey(appointment.status) === normalizeStatusKey(statusFilter)

    const today = new Date().toISOString().split("T")[0]
    const tomorrow = new Date(Date.now() + 24 * 60 * 60 * 1000)
      .toISOString()
      .split("T")[0]

    const aptDate =
      appointment.appointment_date ??
      appointment.appointmentDate ??
      (appointment.date ? new Date(appointment.date).toISOString().split("T")[0] : "")

    const matchesDate =
      dateFilter === "all" ||
      (dateFilter === "today" && aptDate === today) ||
      (dateFilter === "tomorrow" && aptDate === tomorrow)

    return matchesSearch && matchesStatus && matchesDate
  })

  // ----------------------
  // Icons & utilities
  // ----------------------
  const getStatusIcon = (status) => {
    const s = normalizeStatusKey(status)
    switch (s) {
      case "completed":
        return <FaCheckCircle />
      case "scheduled":
        return <FaClock />
      case "in progress":
        return <FaExclamationTriangle />
      case "cancelled":
        return <FaTimesCircle />
      default:
        return <FaExclamationTriangle />
    }
  }

  const badgeStyleFor = (status) => {
    const s = normalizeStatusKey(status)
    if (s === "completed")
      return {
        background: "linear-gradient(135deg, #059669 0%, #047857 100%)",
        border: "none",
      }
    if (s === "scheduled")
      return {
        background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
        border: "none",
      }
    if (s === "in progress")
      return {
        background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
        border: "none",
      }
    return {
      background: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
      border: "none",
    }
  }

  // ----------------------
  // View / Edit handlers
  // ----------------------
  const handleViewDetails = (appointment) => {
    setSelectedAppointment(appointment)
    setShowViewModal(true)
  }

  const handleEdit = (appointment) => {
    // keep the same view layout but allow status edit
    setEditForm({ ...appointment })
    setShowEditModal(true)
  }

  const handleEditSubmit = async (e) => {
    e.preventDefault()
    if (!editForm) return
    setSubmittingEdit(true)

    try {
      // Compose payload similarly to your old code expectations
      const updatedAppointment = {
        id: editForm.id ?? editForm._id,
        patientId: String(
          editForm.patient_id ?? editForm.patientId ?? editForm.patient?.id ?? ""
        ),
        doctorName: editForm.doctor_name ?? editForm.doctorName ?? "",
        appointmentDate: new Date(
          editForm.appointment_date ?? editForm.appointmentDate
        )
          .toISOString()
          .slice(0, 10),
        appointmentTime: (editForm.appointment_time ?? editForm.appointmentTime ?? "")
          .toString()
          .slice(0, 5),
        notes: editForm.notes ?? "",
        price: editForm.price ?? "",
        adminId: user?.id,
        status: editForm.status,
      }

      const id = editForm.id ?? editForm._id
      const response = await apiService.updateAppointment?.(id, updatedAppointment)

      if (response?.success) {
        setMessage({ type: "success", text: "Appointment updated successfully!" })
        setShowEditModal(false)
        fetchAppointments()
      } else {
        console.error("Update failed", response)
        setMessage({ type: "danger", text: "Failed to update appointment" })
      }
    } catch (err) {
      console.error("Error updating appointment", err)
      setMessage({ type: "danger", text: err?.message || "Error updating appointment" })
    } finally {
      setSubmittingEdit(false)
    }
  }

  // ----------------------
  // Create appointment (Schedule)
  // ----------------------
  const openAppointmentModal = () => {
    setShowAppointmentModal(true)
    const today = new Date().toISOString().split("T")[0]
    setAppointmentForm((prev) => ({ ...prev, appointmentDate: today }))
  }

  const handleAppointmentSubmit = async (e) => {
    e.preventDefault()
    setSubmittingCreate(true)

    try {
      const payload = {
        patientId: appointmentForm.patientId,
        doctorName: appointmentForm.doctorName,
        appointmentDate: appointmentForm.appointmentDate,
        appointmentTime: appointmentForm.appointmentTime,
        notes: appointmentForm.notes,
        price: appointmentForm.price,
        adminId: user?.id,
        status: "Scheduled",
      }

      const response = await apiService.createAppointment?.(payload)

      if (response?.success) {
        setMessage({ type: "success", text: "Appointment scheduled successfully!" })
        setShowAppointmentModal(false)
        setAppointmentForm({
          patientId: "",
          doctorName: "",
          appointmentDate: "",
          appointmentTime: "",
          notes: "",
          price: "",
        })
        fetchAppointments()
      } else {
        console.error("Create failed", response)
        setMessage({ type: "danger", text: "Failed to schedule appointment" })
      }
    } catch (err) {
      console.error("Error creating appointment", err)
      setMessage({ type: "danger", text: err?.message || "Failed to schedule appointment" })
    } finally {
      setSubmittingCreate(false)
    }
  }

  // ----------------------
  // JSX
  // ----------------------
  return (
    <div className="min-vh-100" style={{ backgroundColor: "#f8fffe" }}>
      <Container className="py-5">
        {/* Header */}
        <div className="mb-5">
          <div
            className="p-5 rounded-4 text-white position-relative overflow-hidden"
            style={{
              background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
            }}
          >
            {/* Background Pattern */}
            <div className="position-absolute w-100 h-100 top-0 start-0">
              <div
                className="position-absolute rounded-circle opacity-10"
                style={{
                  width: "200px",
                  height: "200px",
                  background: "white",
                  top: "-50px",
                  right: "-50px",
                }}
              ></div>
            </div>

            <Row className="align-items-center position-relative">
              <Col md={8}>
                <div className="mb-3">
                  <Badge
                    className="px-3 py-2 rounded-pill fw-medium mb-3"
                    style={{
                      backgroundColor: "rgba(255, 255, 255, 0.2)",
                      backdropFilter: "blur(10px)",
                      border: "1px solid rgba(255, 255, 255, 0.3)",
                    }}
                  >
                    <FaShieldAlt className="me-2" />
                    Appointment Management
                  </Badge>
                </div>
                <h1 className="display-5 fw-bold mb-3">Appointment Schedule</h1>
                <p className="fs-5 opacity-90 mb-4">Manage and monitor all Aidify appointments</p>
                <Button
                  variant="light"
                  className="px-4 py-2 rounded-pill fw-medium"
                  style={{
                    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                  }}
                  onClick={openAppointmentModal}
                >
                  <FaPlus className="me-2" style={{ color: "#0891b2" }} />
                  <span style={{ color: "#0891b2" }}>Schedule Appointment</span>
                </Button>
              </Col>
              <Col md={4} className="text-end">
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-circle"
                  style={{
                    width: "120px",
                    height: "120px",
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                    backdropFilter: "blur(20px)",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                  }}
                >
                  <FaCalendarAlt size={48} />
                </div>
              </Col>
            </Row>
          </div>
        </div>

        {/* Stats Cards */}
        <Row className="g-4 mb-5">
          <Col md={3}>
            <Card
              className="border-0 rounded-4 h-100"
              style={{
                boxShadow: "0 10px 40px rgba(8, 145, 178, 0.15)",
                background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
              }}
            >
              <Card.Body className="p-4 text-white text-center">
                <FaClock size={32} className="mb-3" />
                <div className="h3 fw-bold mb-1">{scheduledAppointments}</div>
                <div className="opacity-90">Scheduled</div>
              </Card.Body>
            </Card>
          </Col>

          <Col md={3}>
            <Card
              className="border-0 rounded-4 h-100"
              style={{
                boxShadow: "0 10px 40px rgba(5, 150, 105, 0.15)",
                background: "linear-gradient(135deg, #059669 0%, #047857 100%)",
              }}
            >
              <Card.Body className="p-4 text-white text-center">
                <FaCheckCircle size={32} className="mb-3" />
                <div className="h3 fw-bold mb-1">{completedAppointments}</div>
                <div className="opacity-90">Completed</div>
              </Card.Body>
            </Card>
          </Col>

          <Col md={3}>
            <Card
              className="border-0 rounded-4 h-100"
              style={{
                boxShadow: "0 10px 40px rgba(245, 158, 11, 0.15)",
                background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
              }}
            >
              <Card.Body className="p-4 text-white text-center">
                <FaExclamationTriangle size={32} className="mb-3" />
                <div className="h3 fw-bold mb-1">{inProgressAppointments}</div>
                <div className="opacity-90">In Progress</div>
              </Card.Body>
            </Card>
          </Col>

          <Col md={3}>
            <Card
              className="border-0 rounded-4 h-100"
              style={{
                boxShadow: "0 10px 40px rgba(220, 38, 38, 0.15)",
                background: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
              }}
            >
              <Card.Body className="p-4 text-white text-center">
                <FaTimesCircle size={32} className="mb-3" />
                <div className="h3 fw-bold mb-1">{cancelledAppointments}</div>
                <div className="opacity-90">Cancelled</div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Filters */}
        <Card className="border-0 rounded-4 mb-4" style={{ boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)" }}>
          <Card.Header className="bg-transparent border-0 p-4">
            <div className="d-flex align-items-center">
              <div
                className="rounded-circle me-3 d-flex align-items-center justify-content-center"
                style={{
                  width: "40px",
                  height: "40px",
                  background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                  color: "white",
                }}
              >
                <FaFilter size={18} />
              </div>
              <div>
                <h5 className="fw-bold mb-1" style={{ color: "#1f2937" }}>
                  Filter Appointments
                </h5>
                <p className="text-muted mb-0">Search and filter appointment records</p>
              </div>
            </div>
          </Card.Header>
          <Card.Body className="p-4">
            <Row className="g-3">
              <Col md={6}>
                <div className="position-relative">
                  <FaSearch className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted" />
                  <Form.Control
                    type="text"
                    placeholder="Search by patient, doctor, or specialty..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="ps-5 rounded-3 border-0"
                    style={{
                      backgroundColor: "#f0fdfa",
                      boxShadow: "0 0 0 1px #a7f3d0",
                    }}
                  />
                </div>
              </Col>
              <Col md={3}>
                <Form.Select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  className="rounded-3 border-0"
                  style={{
                    backgroundColor: "#f0fdfa",
                    boxShadow: "0 0 0 1px #a7f3d0",
                  }}
                >
                  <option value="all">All Status</option>
                  <option value="Scheduled">Scheduled</option>
                  <option value="In Progress">In Progress</option>
                  <option value="Completed">Completed</option>
                  <option value="Cancelled">Cancelled</option>
                </Form.Select>
              </Col>
              <Col md={3}>
                <Form.Select
                  value={dateFilter}
                  onChange={(e) => setDateFilter(e.target.value)}
                  className="rounded-3 border-0"
                  style={{
                    backgroundColor: "#f0fdfa",
                    boxShadow: "0 0 0 1px #a7f3d0",
                  }}
                >
                  <option value="all">All Dates</option>
                  <option value="today">Today</option>
                  <option value="tomorrow">Tomorrow</option>
                </Form.Select>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Appointments List */}
        <Card className="border-0 rounded-4" style={{ boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)" }}>
          <Card.Header className="bg-transparent border-0 p-4">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h5 className="fw-bold mb-1" style={{ color: "#1f2937" }}>
                  Appointment Records
                </h5>
                <p className="text-muted mb-0">{filteredAppointments.length} appointment(s) found</p>
              </div>
            </div>
          </Card.Header>
          <Card.Body className="p-0">
            {loading ? (
              <div className="text-center py-5">
                <Spinner animation="border" variant="primary" className="me-3" />
                <span>Loading appointments...</span>
              </div>
            ) : filteredAppointments.length > 0 ? (
              <div className="d-flex flex-column">
                {filteredAppointments.map((appointment, index) => {
                  const key = appointment.id ?? appointment._id
                  return (
                    <div
                      key={key}
                      className={`p-4 d-flex justify-content-between align-items-center ${
                        index !== filteredAppointments.length - 1 ? "border-bottom" : ""
                      }`}
                      style={{
                        borderColor: "#a7f3d0",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f0fdfa"
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent"
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <div
                          className="rounded-circle me-4 d-flex align-items-center justify-content-center"
                          style={{
                            width: "60px",
                            height: "60px",
                            background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                            color: "white",
                          }}
                        >
                          <FaStethoscope size={24} />
                        </div>
                        <div>
                          <div className="fw-bold mb-1" style={{ color: "#1f2937" }}>
                            {appointment.patient_name ?? appointment.patient?.name ?? "Unknown"}
                          </div>
                          <div className="text-muted mb-1">{appointment.doctor_name ?? appointment.doctorName}</div>
                          <div className="text-muted small mb-1">{appointment.notes || "No notes"}</div>
                          <div className="d-flex align-items-center text-muted small">
                            <FaCalendarAlt className="me-1" size={12} />
                            {appointment.appointment_date ?? appointment.appointmentDate} at {appointment.appointment_time ?? appointment.appointmentTime}
                          </div>
                        </div>
                      </div>
                      <div className="text-end">
                        <Badge
                          className="mb-2 d-flex align-items-center gap-1 w-fit ms-auto"
                          style={badgeStyleFor(appointment.status)}
                        >
                          {getStatusIcon(appointment.status)}
                          {appointment.status}
                        </Badge>
                        <div className="d-flex gap-2">
                          <Button
                            size="sm"
                            variant="outline-primary"
                            className="rounded-pill"
                            onClick={() => handleViewDetails(appointment)}
                            style={{ borderColor: "#0891b2", color: "#0891b2" }}
                          >
                            <FaEye className="me-1" size={12} />
                            View
                          </Button>
                          <Button
                            size="sm"
                            variant="outline-success"
                            className="rounded-pill"
                            onClick={() => handleEdit(appointment)}
                          >
                            <FaEdit className="me-1" size={12} />
                            Edit
                          </Button>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            ) : (
              <div className="text-center py-5">
                <FaCalendarAlt size={64} className="text-muted mb-3" />
                <h5 className="text-muted mb-2">No appointments found</h5>
                <p className="text-muted mb-4">Try adjusting your search criteria or schedule a new appointment</p>
                <Button
                  className="px-4 py-2 rounded-pill fw-medium border-0"
                  style={{
                    background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                  }}
                  onClick={openAppointmentModal}
                >
                  <FaPlus className="me-2" />
                  Schedule New Appointment
                </Button>
              </div>
            )}
          </Card.Body>
        </Card>

        {/* View Modal */}
        <Modal show={showViewModal} onHide={() => setShowViewModal(false)} size="lg" centered>
          <Modal.Header closeButton className="border-0">
            <Modal.Title>Appointment Details</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            {selectedAppointment && (
              <Row className="g-4">
                <Col md={6}>
                  <h6 className="fw-bold mb-3" style={{ color: "#0891b2" }}>
                    Appointment Information
                  </h6>
                  <div className="mb-3">
                    <strong>Date:</strong> {selectedAppointment.appointment_date ?? selectedAppointment.appointmentDate}
                  </div>
                  <div className="mb-3">
                    <strong>Time:</strong> {selectedAppointment.appointment_time ?? selectedAppointment.appointmentTime}
                  </div>
                  <div className="mb-3">
                    <strong>Status:</strong>
                    <Badge
                      className="ms-2"
                      style={badgeStyleFor(selectedAppointment.status)}
                    >
                      {selectedAppointment.status}
                    </Badge>
                  </div>
                  <div className="mb-3">
                    <strong>Patient:</strong> {selectedAppointment.patient_name ?? selectedAppointment.patient?.name}
                  </div>
                  <div className="mb-3">
                    <strong>Doctor:</strong> {selectedAppointment.doctor_name ?? selectedAppointment.doctorName}
                  </div>
                  {selectedAppointment.price && (
                    <div className="mb-3">
                      <strong>Price:</strong> ${selectedAppointment.price}
                    </div>
                  )}
                  {selectedAppointment.notes && (
                    <div className="mb-3">
                      <strong>Notes:</strong> {selectedAppointment.notes}
                    </div>
                  )}
                </Col>
                <Col md={6}>
                  <h6 className="fw-bold mb-3" style={{ color: "#0891b2" }}>
                    Additional Information
                  </h6>
                  <div className="mb-3">
                    <strong>Created:</strong>{" "}
                    {selectedAppointment.created_at
                      ? new Date(selectedAppointment.created_at).toLocaleDateString()
                      : selectedAppointment.createdAt
                      ? new Date(selectedAppointment.createdAt).toLocaleDateString()
                      : "N/A"}
                  </div>
                  {selectedAppointment.notes && (
                    <div className="mb-3">
                      <strong>Notes:</strong> {selectedAppointment.notes}
                    </div>
                  )}
                </Col>
              </Row>
            )}
          </Modal.Body>
          <Modal.Footer className="border-0">
            <Button variant="outline-secondary" onClick={() => setShowViewModal(false)}>
              Close
            </Button>
            <Button
              style={{
                background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                border: "none",
              }}
              onClick={() => {
                // Open edit modal pre-filled with same appointment
                if (selectedAppointment) {
                  setEditForm({ ...selectedAppointment })
                  setShowEditModal(true)
                }
              }}
            >
              <FaEdit className="me-2" />
              Edit Appointment
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Modal (same layout as view but status editable) */}
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg" centered>
          <Modal.Header closeButton className="border-0">
            <Modal.Title>Edit Appointment</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            {editForm && (
              <Row className="g-4">
                <Col md={6}>
                  <h6 className="fw-bold mb-3" style={{ color: "#0891b2" }}>
                    Appointment Information
                  </h6>
                  <div className="mb-3">
                    <strong>Date:</strong> {editForm.appointment_date ?? editForm.appointmentDate}
                  </div>
                  <div className="mb-3">
                    <strong>Time:</strong> {editForm.appointment_time ?? editForm.appointmentTime}
                  </div>
                  <div className="mb-3">
                    <strong>Status:</strong>
                    <Form.Select
                      value={editForm.status ?? "Scheduled"}
                      onChange={(e) => setEditForm({ ...editForm, status: e.target.value })}
                      className="d-inline-block ms-2"
                      style={{ width: "180px" }}
                    >
                      <option value="Scheduled">Scheduled</option>
                      <option value="In Progress">In Progress</option>
                      <option value="Completed">Completed</option>
                      <option value="Cancelled">Cancelled</option>
                    </Form.Select>
                  </div>
                  <div className="mb-3">
                    <strong>Patient:</strong> {editForm.patient_name ?? editForm.patient?.name}
                  </div>
                  <div className="mb-3">
                    <strong>Doctor:</strong> {editForm.doctor_name ?? editForm.doctorName}
                  </div>
                  {editForm.price && (
                    <div className="mb-3">
                      <strong>Price:</strong> ${editForm.price}
                    </div>
                  )}
                  {editForm.notes && (
                    <div className="mb-3">
                      <strong>Notes:</strong> {editForm.notes}
                    </div>
                  )}
                </Col>
                <Col md={6}>
                  <h6 className="fw-bold mb-3" style={{ color: "#0891b2" }}>
                    Additional Information
                  </h6>
                  <div className="mb-3">
                    <strong>Created:</strong>{" "}
                    {editForm.created_at
                      ? new Date(editForm.created_at).toLocaleDateString()
                      : editForm.createdAt
                      ? new Date(editForm.createdAt).toLocaleDateString()
                      : "N/A"}
                  </div>
                </Col>
              </Row>
            )}
          </Modal.Body>
          <Modal.Footer className="border-0">
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={(e) => {
                // reuse edit submit handler
                // wrap in a synthetic form submit to keep behaviour consistent
                const fakeEvent = { preventDefault: () => {} }
                handleEditSubmit(fakeEvent)
              }}
              disabled={submittingEdit}
            >
              {submittingEdit ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Saving...
                </>
              ) : (
                "Save Changes"
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Schedule Appointment Modal */}
        <Modal show={showAppointmentModal} onHide={() => setShowAppointmentModal(false)} size="lg" centered>
          <Modal.Header closeButton style={{ backgroundColor: "#f0fdfa" }}>
            <Modal.Title>
              <FaCalendarPlus className="me-2" />
              Schedule New Appointment
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {message.text && (
              <Alert variant={message.type} dismissible onClose={() => setMessage({ type: "", text: "" })}>
                {message.text}
              </Alert>
            )}

            <Form onSubmit={handleAppointmentSubmit}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Patient <span className="text-danger">*</span></Form.Label>
                    <Form.Select
                      required
                      value={appointmentForm.patientId}
                      onChange={(e) => setAppointmentForm((prev) => ({ ...prev, patientId: e.target.value }))}
                    >
                      <option value="">Select Patient</option>
                      {patients.map((patient) => {
                        const id = patient.id ?? patient._id ?? patient.patientId
                        const label = patient.name ?? patient.full_name ?? patient.email ?? `#${id}`
                        return (
                          <option key={id} value={id}>
                            {label}
                          </option>
                        )
                      })}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Doctor <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter doctor name"
                      value={appointmentForm.doctorName}
                      onChange={(e) => setAppointmentForm((prev) => ({ ...prev, doctorName: e.target.value }))}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Appointment Date <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="date"
                      required
                      value={appointmentForm.appointmentDate}
                      onChange={(e) => setAppointmentForm((prev) => ({ ...prev, appointmentDate: e.target.value }))}
                      min={new Date().toISOString().split("T")[0]}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Appointment Time <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="time"
                      required
                      value={appointmentForm.appointmentTime}
                      onChange={(e) => setAppointmentForm((prev) => ({ ...prev, appointmentTime: e.target.value }))}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Price</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Enter price"
                      value={appointmentForm.price}
                      onChange={(e) => setAppointmentForm((prev) => ({ ...prev, price: e.target.value }))}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label>Notes</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Additional notes..."
                  value={appointmentForm.notes}
                  onChange={(e) => setAppointmentForm((prev) => ({ ...prev, notes: e.target.value }))}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0fdfa" }}>
            <Button variant="secondary" onClick={() => setShowAppointmentModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleAppointmentSubmit} disabled={submittingCreate}>
              {submittingCreate ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Scheduling...
                </>
              ) : (
                <>
                  <FaCalendarPlus className="me-2" />
                  Schedule Appointment
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  )
}
